import { transformValidator } from '@databases/types/validators';
import { z } from 'zod';

/**
 * Returns a zod schema that takes a number string as an input and creates the parsed number as an output.
 * @param schema A schema can be specified here to parse the transformed number value (number/undefined).
 *               Examples would be z.number() or z.number().optional().
 */
export function numberStringValidator<Output>(
  schema: z.ZodType<Output, any, number | undefined>
): z.ZodEffects<
  z.ZodEffects<
    z.ZodType<string | undefined, any, string | undefined>,
    string | undefined
  >,
  Output
> {
  return transformValidator(
    z.string().optional(),
    (val) => (val == null ? val : isNaN(Number(val)) ? undefined : Number(val)),
    schema
  );
}
